import { ReactElement, useCallback } from 'react';
import { OptimizedImage } from '@cars4ever/media-utils';
import classNames from 'classnames';

import ICarColor from '^types/ICarColor';

import styles from './styles.module.scss';

interface IColorOptionProps {
  isSelected: boolean;
  color: ICarColor;
  onSelect: (color: ICarColor) => void;
}

const ColorOption = ({ color, isSelected, onSelect }: IColorOptionProps): ReactElement => {
  const handleClick = useCallback(
    (): void => {
      onSelect(color);
    },
    [color, onSelect],
  );

  return (
    <div
      className={classNames(styles.colorOption, {
        [styles.selected]: isSelected,
      })}
      onClick={handleClick}
    >
      <OptimizedImage
        variant="cover"
        className={styles.colorIcon}
        publicId={color.iconToken}
      />
    </div>
  );
};

export default ColorOption;
